module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline-item",
    class: _vm.typeClass
  }, [(_vm.icon) ? _c('div', {
    staticClass: "timeline-icon"
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.iconClass
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "timeline-item-main"
  }, [_c('div', {
    staticClass: "timeline-item-date"
  }, [_vm._v(_vm._s(_vm.date))]), _vm._v(" "), _c('div', {
    staticClass: "timeline-item-content"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e22b7538!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timeline/TimelineItem.vue
// module id = 357
// module chunks = 0